document.addEventListener("DOMContentLoaded", () => {
  document.addEventListener("click", (e) => {
    const el = e.target.closest("#open-zoom-meeting-popup");
    if (!el) return;

    onOpenZoomMeetingPopup.call(el, e);
  });
});

function onOpenZoomMeetingPopup(event) {
  const tsDateId = event.target.dataset.tsDateId;
  document.getElementById("zoom-meeting-ts-date-id").value = tsDateId;
}
